import numeral from 'numeral';

export const createNumeralFormatter =
  (format = '0,0.00') =>
  (dataValue: number): string | number => {
    if (!Number.isFinite(dataValue)) {
      return dataValue;
    }

    return numeral(dataValue).format(format);
  };
